<nav class="navbar fixed-top navbar-expand-lg" *ngIf="!showOnMobile" [ngClass]="{'brand-header-solid': !isTransparentHeaderRoute || navWhiteBg, 'transparent-nav': isTransparentHeaderRoute && !navWhiteBg}">
    <div class="header-inner-container">
        <div class="header-left-brands">
            <div class="navbar-brand">
                <img alt="Mihuru" class="brand-mihuru-logo" src="../../../assets/images/logoitrevele-black.png">
            </div>
            <div class="navbar-brand partner-brand-container" *ngIf="isParterLogo && partnerLogourl">
                <c class="partner-prefix">in partnership with</c>
                <img alt="Partner" class="partner-logo-img" [src]="partnerLogourl" (error)="onPartnerLogoError()">
            </div>
        </div>
        <div class="header-right-action text-right">
            <app-session-timeout></app-session-timeout>
            <div class="header-contact-details">
                <a href="tel:+918040582421" class="contact-phone">+91 8040582421</a>
                <a href="mailto:support@mihuru.com" class="contact-email">support&#64;mihuru.com</a>
            </div>
        </div>
    </div>
</nav>

<nav #menu1 class="navbar fixed-top navbar-expand-sm" *ngIf="showOnMobile" [ngClass]="{'brand-header-solid': !isTransparentHeaderRoute || navWhiteBg, 'transparent-nav': isTransparentHeaderRoute && !navWhiteBg}">
    <div class="header-inner-container mobile-header-inner">
        <div class="header-left-brands mobile-brands">
            <div class="navbar-brand">
                <img alt="Mihuru" class="brand-mihuru-logo" src="../../../assets/images/logoitrevele-black.png">
            </div>
            <div class="navbar-brand partner-brand-container" *ngIf="isParterLogo && partnerLogourl">
                <c class="partner-prefix">in partnership with</c>
                <img alt="Partner" class="partner-logo-img" [src]="partnerLogourl" (error)="onPartnerLogoError()">
            </div>
        </div>
        <div class="header-right-action text-right">
            <app-session-timeout></app-session-timeout>
            <div class="header-contact-details">
                <a href="tel:+918040582421" class="contact-phone">+91 8040582421</a>
                <a href="mailto:support@mihuru.com" class="contact-email">support&#64;mihuru.com</a>
            </div>
        </div>
    </div>
</nav>